import React from 'react';

import styled from 'styled-components';

import { useCurrentProjectId } from '@adsk/alloy-provider';
import { FanIcon } from '@adsk/alloy-react-icon';
import StatusColorIndicator from '@adsk/alloy-react-status-color-indicator';

import getAssetUrl from './helpers/getAssetUrl';
import { Asset } from './types';
import EntityMenuItem from '../../EntityMenuItem';
import ReferencePickerPlugin from '../../types/ReferencePickerPlugin';

const Label = styled.div`
  align-items: center;
  display: inline-flex;
`;

const Name = styled.div`
  margin-left: 3px;
`;

const SmallStatusColorIndicator = styled(StatusColorIndicator)`
  width: 3px;
  height: 16px;
  cursor: default;
`;

const AssetsEntityMenuItem: Exclude<
  ReferencePickerPlugin<Asset>['EntityMenuItem'],
  undefined
> = ({ entity, ...rest }) => {
  const projectId = useCurrentProjectId();
  const { id, clientAssetId, status } = entity;
  const label = (
    <Label>
      {status && <SmallStatusColorIndicator color={status.color} />}
      <Name>{clientAssetId}</Name>
    </Label>
  );

  return (
    <EntityMenuItem
      link={projectId ? getAssetUrl(projectId, id) : undefined}
      label={label}
      renderIcon={(p) => <FanIcon {...p} />}
      {...rest}
    />
  );
};

export default AssetsEntityMenuItem;
